// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Numeral = require("../../../utils/Numeral.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useIsValid(draft) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, draft);
  let match$1 = draft$1.draftProperty;
  let price = match$1.price;
  if (price === undefined) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  if (match$1.propertyType === "FOR_SALE") {
    if (price < 50000) {
      return {
        NAME: "Error",
        VAL: "must be $50,000 or greater"
      };
    }
  } else if (price < 750) {
    return {
      NAME: "Error",
      VAL: "must be $750 or greater"
    };
  }
  if (price > 250000000) {
    return {
      NAME: "Error",
      VAL: "must be $250,000,000 or less"
    };
  }
  if (typeof mode !== "object") {
    return "Valid";
  }
  if (mode.TAG !== "Rebroadcast") {
    return "Valid";
  }
  let match$2 = mode._1.broadcastPolicy;
  switch (match$2.__typename) {
    case "PropertyBroadcastAllowed" :
      let match$3 = match$2.priceCondition;
      if (match$3 === undefined) {
        return "Valid";
      }
      let priceToRebroadcast = match$3.maxPrice.value;
      if (price <= priceToRebroadcast) {
        return "Valid";
      }
      let priceToRebroadcast$1 = Numeral.formatPrice(priceToRebroadcast);
      return {
        NAME: "Error",
        VAL: `must be ` + priceToRebroadcast$1 + ` or lower to rebroadcast`
      };
    case "PropertyBroadcastNotAllowed" :
    case "__unselected" :
      return "Valid";
  }
}

let ExactPrice = {
  DraftFragment: DraftFragment,
  useIsValid: useIsValid
};

let convertFragment$1 = PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment_localDraftPropertyType_decode$1 = PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString$1 = PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$1 = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode$1,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid$1(draft) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPriceMinPrice_draft_graphql.node, convertFragment$1, draft);
  let match$1 = draft$1.draftProperty;
  let minPrice = match$1.minPrice;
  if (minPrice === undefined) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  if (match$1.propertyType === "FOR_SALE") {
    if (minPrice < 50000) {
      return {
        NAME: "Error",
        VAL: "must be $50,000 or greater"
      };
    }
  } else if (minPrice < 750) {
    return {
      NAME: "Error",
      VAL: "must be $750 or greater"
    };
  }
  if (minPrice > 250000000) {
    return {
      NAME: "Error",
      VAL: "must be $250,000,000 or less"
    };
  }
  if (typeof mode !== "object") {
    return "Valid";
  }
  if (mode.TAG !== "Rebroadcast") {
    return "Valid";
  }
  let match$2 = mode._1.broadcastPolicy;
  switch (match$2.__typename) {
    case "PropertyBroadcastAllowed" :
      let match$3 = match$2.priceCondition;
      if (match$3 === undefined) {
        return "Valid";
      }
      let priceToRebroadcast = match$3.maxPrice.value;
      if (minPrice <= priceToRebroadcast) {
        return "Valid";
      }
      let priceToRebroadcast$1 = Numeral.formatPrice(priceToRebroadcast);
      return {
        NAME: "Error",
        VAL: `must be ` + priceToRebroadcast$1 + ` or lower to rebroadcast`
      };
    case "PropertyBroadcastNotAllowed" :
    case "__unselected" :
      return "Valid";
  }
}

let MinPrice = {
  DraftFragment: DraftFragment$1,
  useIsValid: useIsValid$1
};

let convertFragment$2 = PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.node, convertFragment$2, fRef);
}

let DraftFragment_localDraftPropertyType_decode$2 = PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString$2 = PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$2 = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode$2,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString$2,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function useIsValid$2(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPriceMaxPrice_draft_graphql.node, convertFragment$2, draft);
  let match = draft$1.draftProperty;
  let maxPrice = match.maxPrice;
  if (maxPrice === undefined) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
  let minPrice = match.minPrice;
  if (match.propertyType === "FOR_SALE") {
    if (maxPrice < 100000) {
      return {
        NAME: "Error",
        VAL: "must be $100,000 or greater"
      };
    }
  } else if (maxPrice < 750) {
    return {
      NAME: "Error",
      VAL: "must be $750 or greater"
    };
  }
  if (maxPrice > 250000000) {
    return {
      NAME: "Error",
      VAL: "must be $250,000,000 or less"
    };
  }
  if (minPrice === undefined) {
    return "Valid";
  }
  if (minPrice <= maxPrice) {
    return "Valid";
  }
  let tmp;
  tmp = match.propertyType === "FOR_SALE" ? "must be greater than the lower price" : "must be greater than the lower rent";
  return {
    NAME: "Error",
    VAL: tmp
  };
}

let MaxPrice = {
  DraftFragment: DraftFragment$2,
  useIsValid: useIsValid$2
};

let convertFragment$3 = PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql.node, convertFragment$3, fRef);
}

let DraftFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useIsValid$3(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPrice_draft_graphql.node, convertFragment$3, draft);
  let isMinPriceValid = useIsValid$1(draft$1.fragmentRefs);
  let isMaxPriceValid = useIsValid$2(draft$1.fragmentRefs);
  let isExactPriceValid = useIsValid(draft$1.fragmentRefs);
  if (draft$1.draftProperty.priceRange) {
    return PropertyWizardRelayUtils.FormUtils.allValid([
      isMinPriceValid,
      isMaxPriceValid
    ]);
  } else {
    return PropertyWizardRelayUtils.FormUtils.allValid([isExactPriceValid]);
  }
}

let FormUtils;

exports.FormUtils = FormUtils;
exports.ExactPrice = ExactPrice;
exports.MinPrice = MinPrice;
exports.MaxPrice = MaxPrice;
exports.DraftFragment = DraftFragment$3;
exports.useIsValid = useIsValid$3;
/* Numeral Not a pure module */
